import { render, staticRenderFns } from "./BensPermanentesTab.vue?vue&type=template&id=75a81f6a"
import script from "./BensPermanentesTab.vue?vue&type=script&lang=js"
export * from "./BensPermanentesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports